import { CommonModels } from './common.models';
import { DocumentModels } from './document.models';

export namespace SignatureModels {
  export class SignatureInfo {
    public signatureId?: string;
    public transactionId?: string;
    public code?: string;
  }

  /** Mode d'envoi  */
  export enum SendModeEnum {
    Sms = 1,
    Email = 2,
  }

  /** Type de signature */
  export enum SignatureTypeEnum {
    Electronic = 1,
    Handwritten = 2,
  }

  export class Recap {
    agencyContractFileId?: number;
    agencyName?: string;
    lastName?: string;
    firstName?: string;
    email?: string;
    mobile?: string;
    civility?: CommonModels.CivilityEnum;
  }

  export interface SignatureOrderDetails {
    id: number;
    quotePublicId: string;
    policyPublicId: string;
    fileName: string;
    expiracyDate: Date;
    signatureDate?: Date;
    email?: string;
    mobile?: string;
    creationDate: Date;
    suiviUrl: string;
    documentType?: DocumentModels.DocumentType;
  }

  export interface SignatureTransaction {
    id: string;
    quotePublicId?: string;
    isAccounted: boolean;
    signatureDate?: Date;
  }

  export interface StartSignatureResponse {
    signatureUrl: string;
  }
}
